export default "__VITE_ASSET__C_YV4BOn__"